<template>
  <ab-flow-base-cmp :movable="true" :block="block" class="text-generator-editor-cmp">

    <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>

    <q-card class="card">

      <q-card-section class="bg-purple text-white q-py-sm">
        {{ title }}
      </q-card-section>

    </q-card>

    <div class="results">
      <ab-flow-link-connector :block="block" type="output" event="result"/>
      <ab-flow-link-connector :block="block" type="output" event="cancel"/>
      <ab-flow-link-connector :block="block" type="output" event="error"/>
    </div>

  </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";
import {renderMixins} from '@/components/DiagramDesigner/Editor/components/renderMixins';

export default {
  components: {AbFlowBaseCmp, AbFlowLinkConnector},

  mixins: [renderMixins],

  inject: ['canvas'],
  props: ['block'],
  name: "SchemaGeneratorEditorCmp",

  computed: {
    // Get the title property from the block
    title() {
      return this.block?.properties?.title || 'Schema generator';
    },
  },
}

</script>

<style lang="scss">

.text-generator-editor-cmp {
  position: relative;

  .card {
    max-width: 200px;
    word-wrap: break-word;
  }
  .ev-run {
    left: -12px;
    position: absolute;
    z-index: 1;
    top: calc(50% - 5px);
  }
  .results {
    right: -12px;
    position: absolute;
    z-index: 1;
    top: calc(50%);
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    row-gap: 6px;
  }
}

</style>
